import React, { useEffect, useState } from 'react';
import rest from '../../../data/restWrapper';
import PageLoader from '../../../components/loaders/loader1';
import CommunicationError from '../../SRCSettings/communicationError';
import { checkIfRoomHasSettings } from '../../../data/controllers/SRCStatus';
import { ReservationWithIncludedModels, RoomInfoEditModel } from '@common/modelDefinition';
import translate from '@data/translations';
import useStore from '@data/state/zustand';
import { Reservation } from '@pages/newReservations/resController';
import AccessCodes1 from '@pages/SRCSettings/accessCodes1';

interface BasicSRCSettingsProps1 {
    match?: any;
    remoteDeviceId?: string | null;
    roomInfoId: number;
    reservation?: Reservation | ReservationWithIncludedModels;
    showOnlyOneSRC?: boolean;
}

function BasicSRCSettings1(props: BasicSRCSettingsProps1) {
    const [showConnectionError, setShowConnectionError] = useState(false as boolean);
    const [remoteDeviceId, setRemoteDeviceId] = useState(null as string | null);
    const [basicSRCSettings, setBasicSRCSettings] = useState({} as any);
    const [showMessage, setShowMessage] = useState(null as null | string);
    const rooms = useStore.getState().model.RoomInfo;
    const locale: string = useStore((appState: any) => appState.locale);

    useEffect(() => {
        const loadData = async () => {
            let _remoteDeviceId = props.remoteDeviceId ? props.remoteDeviceId : null;
            if (props.match && props.match.params.remoteDeviceId) {
                _remoteDeviceId = props.match.params.remoteDeviceId;
            }
            redrawComponent(_remoteDeviceId);
        };
        loadData().catch((err) => {
            console.log(err);
        });
        // eslint-disable-next-line
    }, [props.remoteDeviceId, rooms?.length]);

    const redrawComponent = async (remoteDeviceId: string | null) => {
        if (remoteDeviceId) {
            if (checkIfRoomHasSettings(remoteDeviceId)) {
                try {
                    setRemoteDeviceId(null);
                    setShowConnectionError(false);
                    let basicSRCSettings = await rest('/src/fetchBasicSRCSettingsByRoomInfoId', 'POST', {
                        roomInfoId: props.roomInfoId,
                        smartRoomControllerId: remoteDeviceId,
                    });
                    setRemoteDeviceId(remoteDeviceId);
                    setBasicSRCSettings(basicSRCSettings);
                    setShowConnectionError(false);
                } catch (err: any) {
                    setShowConnectionError(true);
                    setRemoteDeviceId(remoteDeviceId);
                }
            } else {
                setShowMessage('SRC settings not available for this device. Probably SOS Calling Device.');
            }
        }
    };

    let roomInfo: any = rooms?.find((r: RoomInfoEditModel) => r.id === Number(props.roomInfoId));

    let forceReloadButton = (
        <div className="mb-2">
            <button
                onClick={() => {
                    redrawComponent(remoteDeviceId);
                }}
                className="btn btn-outline-primary"
            >
                <i className="fa fa-refresh mr-2" aria-hidden="true"></i>
                {translate('Force reload')}
            </button>
        </div>
    );

    if (showMessage) {
        return <div>{showMessage}</div>;
    }

    if (showConnectionError) {
        return (
            <div>
                {forceReloadButton}
                <CommunicationError />
            </div>
        );
    }
    if (remoteDeviceId === null) {
        return (
            <PageLoader
                style={{ height: '20rem', paddingTop: '8rem' }}
                header="READING BASIC SRC SETTINGS"
                heading="(please wait)"
            />
        );
    }

    return (
        <div>
            <AccessCodes1
                reservation={props.reservation}
                basicMode={true}
                remoteDeviceId={remoteDeviceId}
                roomSettings={basicSRCSettings}
                locale={locale}
                showOnlyOneSRC={props.showOnlyOneSRC}
                remoteDeviceId1={roomInfo.remoteDeviceId}
                remoteDeviceId2={roomInfo.remoteDeviceId2}
                remoteDeviceId3={roomInfo.remoteDeviceId3}
            />
        </div>
    );
}

export default BasicSRCSettings1;